import messageIcon from "Assets/images/widgetimg/message.png";
import chartIcon1 from "Assets/images/widgetimg/chart01.png";
import chartIcon2 from "Assets/images/widgetimg/chart02.png";
import chartIcon3 from "Assets/images/widgetimg/chart03.png";
import chartIcon4 from "Assets/images/widgetimg/chart04.png";
import chartIcon5 from "Assets/images/widgetimg/chart05.png";
import othericon from "Assets/images/widgetimg/othericon.png";
import apps from "Assets/images/widgetimg/apps.png";
import guide from "Assets/images/widgetimg/guide.png";
import calendar from "Assets/images/widgetimg/calendar.png";
import link from "Assets/images/widgetimg/link.png";
// 报表查询类
export const BaoBiaoChaxunLei = [
    {
        value: "baobiaochaxunlei1",
        src: "baobiaochaxunlei1"
    },
    {
        value: "baobiaochaxunlei2",
        src: "baobiaochaxunlei2"
    },
    {
        value: "baobiaochaxunlei3",
        src: "baobiaochaxunlei3"
    },
    {
        value: "baobiaochaxunlei4",
        src: "baobiaochaxunlei4"
    },
    {
        value: "baobiaochaxunlei5",
        src: "baobiaochaxunlei5"
    },
    {
        value: "baobiaochaxunlei6",
        src: "baobiaochaxunlei6"
    },
    {
        value: "baobiaochaxunlei7",
        src: "baobiaochaxunlei7"
    },
    {
        value: "baobiaochaxunlei8",
        src: "baobiaochaxunlei8"
    }
];
// 业务设置类
export const YeWuSheZhiLei = [
    {
        value: "yewushezhilei1",
        src: "yewushezhilei1"
    },
    {
        value: "yewushezhilei2",
        src: "yewushezhilei2"
    },
    {
        value: "yewushezhilei3",
        src: "yewushezhilei3"
    },
    {
        value: "yewushezhilei4",
        src: "yewushezhilei4"
    },
    {
        value: "yewushezhilei5",
        src: "yewushezhilei5"
    },
    {
        value: "yewushezhilei6",
        src: "yewushezhilei6"
    },
    {
        value: "yewushezhilei7",
        src: "yewushezhilei7"
    },
    {
        value: "yewushezhilei8",
        src: "yewushezhilei8"
    }
];
// 业务设置类
export const JiChuDangAnLei = [
    {
        value: "jichudanganlei1",
        src: "jichudanganlei1"
    },
    {
        value: "jichudanganlei2",
        src: "jichudanganlei2"
    },
    {
        value: "jichudanganlei3",
        src: "jichudanganlei3"
    },
    {
        value: "jichudanganlei4",
        src: "jichudanganlei4"
    },
    {
        value: "jichudanganlei5",
        src: "jichudanganlei5"
    },
    {
        value: "jichudanganlei6",
        src: "jichudanganlei6"
    },
    {
        value: "jichudanganlei7",
        src: "jichudanganlei7"
    },
    {
        value: "jichudanganlei8",
        src: "jichudanganlei8"
    }
];
// 单据维护类
export const DanJuWeiHuLei = [
    {
        value: "danjuweihulei1",
        src: "danjuweihulei1"
    },
    {
        value: "danjuweihulei2",
        src: "danjuweihulei2"
    },
    {
        value: "danjuweihulei3",
        src: "danjuweihulei3"
    },
    {
        value: "danjuweihulei4",
        src: "danjuweihulei4"
    },
    {
        value: "danjuweihulei5",
        src: "danjuweihulei5"
    },
    {
        value: "danjuweihulei6",
        src: "danjuweihulei6"
    },
    {
        value: "danjuweihulei7",
        src: "danjuweihulei7"
    },
    {
        value: "danjuweihulei8",
        src: "danjuweihulei8"
    }
];
// 业务处理类
export const YeWuChuLiLei = [
    {
        value: "yewuchulilei1",
        src: "yewuchulilei1"
    },
    {
        value: "yewuchulilei2",
        src: "yewuchulilei2"
    },
    {
        value: "yewuchulilei3",
        src: "yewuchulilei3"
    },
    {
        value: "yewuchulilei4",
        src: "yewuchulilei4"
    },
    {
        value: "yewuchulilei5",
        src: "yewuchulilei5"
    },
    {
        value: "yewuchulilei6",
        src: "yewuchulilei6"
    },
    {
        value: "yewuchulilei7",
        src: "yewuchulilei7"
    },
    {
        value: "yewuchulilei8",
        src: "yewuchulilei8"
    }
];

//部件图标
export const widgetIconMap = {
    //消息类图标
    messageIconList: [
        {
            value: "/message",
            src: messageIcon
        }
    ],
    //图表类图标
    chartIconList: [
        {
            value: "/chart01",
            src: chartIcon1
        },
        {
            value: "/chart02",
            src: chartIcon2
        },
        {
            value: "/chart03",
            src: chartIcon3
        },
        {
            value: "/chart04",
            src: chartIcon4
        },
        {
            value: "/chart05",
            src: chartIcon5
        },
    ],
    //其他图标
    otherIconList: [
        {
            value: "/othericon",
            src: othericon
        },
    ],
    //公共部件图标（不显示在应用注册里）
    pubWidgetIconList: [
        {
            value: "/apps",
            src: apps
        },
        {
            value: "/guide",
            src: guide
        },
        {
            value: "/calendar",
            src: calendar
        },
        {
            value: "/link",
            src: link
        },
    ]
}